module.exports = "<h1>{{i18n + 'TITLE' | translate}}</h1>\n\n<p *ngIf=\"errorDescription\">{{errorDescription}}</p>\n<p *ngIf=\"!errorDescription\">{{i18n + 'MESSAGE' | translate}}</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/unauthorized/unauthorized.component.html
// module id = 823
// module chunks = 3